import React from 'react';
import { Route } from 'react-router-dom';
import TemplateIntranet from 'components/TemplateIntranet';
import TemplateRestaurante from 'components/TemplateRestaurante';
import SessaoExpiradaPage from 'modules/intranet/SessaoExpiradaPage';
import NotFoundPage from 'modules/intranet/NotFoundPage';
import ForbiddenPage from 'modules/intranet/ForbiddenPage';
import HomePage from 'modules/intranet/HomePage';
import FiscalContabilRoutes from 'modules/intranet/fiscal-contabil/Routes';
import ControladoriaRoutes from 'modules/intranet/controladoria/Routes';
import CombustivelRoutes from 'modules/intranet/combustivel/Routes';
import SwitchRouter from 'components/SwitchRouter';
import LoginPage from 'modules/restaurante/LoginPage';
import HomePageRest from 'modules/restaurante/HomePage';
import DepartamentoPessoalRoutes from 'modules/intranet/departamento-pessoal/Routes';
import RecebiveisRoutes from 'modules/intranet/recebiveis/Routes';
import FechamentoCaixaRoutes from 'modules/restaurante/fechamento-de-caixa/Routes';
import UploadExtratoCartao from 'modules/restaurante/conciliacao-cartao/upload-cartao/UploadExtratoCartao';
import Relatorio from 'modules/restaurante/contas-a-pagar/Inicio';
import InicioExtrato from 'modules/restaurante/conciliacao-cartao/extrato_cartoes/InicioExtrato';
import CartaoXCaixa from 'modules/restaurante/conciliacao-cartao/conciliacao-cartao-x-caixa/CartaoXCaixa';
import ExtratoResumo from 'modules/restaurante/movimentacao/extrato-resumo/Inicio';
import ValidFiscoRoutes from 'modules/intranet/valid-fisco/Routes';
import FinanceiroRoutes from 'modules/intranet/financeiro/Routes';
import ResumoRede from 'modules/restaurante/movimentacao/resumo-rede/Inicio';
import ControlDocsRoutes from 'modules/intranet/control-docs/Routes';
import TemplateControlDocs from 'components/TemplateControlDocs';
import Manual from 'modules/control-docs/manual/Manual';

import login from 'modules/intranet/login'

export default function Routes() {
    return (
        <Route
            render={(props) => {
                switch (props.location.pathname.split('/')[1]) {
                    case 'restaurante':
                        return (
                            <TemplateRestaurante {...props}>
                                <SwitchRouter>
                                    <Route exact path="/restaurante" component={LoginPage} />
                                    <Route path="/restaurante/inicio" component={HomePageRest} />
                                    <Route
                                        path="/restaurante/fechamento-de-caixa"
                                        component={FechamentoCaixaRoutes}
                                    />
                                    <Route
                                        path="/restaurante/conciliacao-cartao/upload"
                                        component={UploadExtratoCartao}
                                    />
                                    <Route
                                        path="/restaurante/contas-a-pagar/relatorio"
                                        component={Relatorio}
                                    />
                                    <Route
                                        path="/restaurante/conciliacao-cartao/extrato"
                                        component={InicioExtrato}
                                    />
                                    <Route
                                        path="/restaurante/conciliacao-cartao/cartao-x-caixa"
                                        component={CartaoXCaixa}
                                    />
                                    <Route
                                        path="/restaurante/movimentacao/extrato-resumo"
                                        component={ExtratoResumo}
                                    />
                                    <Route
                                        path="/restaurante/movimentacao/resumo-rede"
                                        component={ResumoRede}
                                    />
                                </SwitchRouter>
                            </TemplateRestaurante>
                        );

                    case 'controldocs':
                        return (
                            <TemplateControlDocs {...props}>
                                <SwitchRouter>
                                    <Route exact path="/controldocs/manual" component={Manual} />
                                </SwitchRouter>
                            </TemplateControlDocs>
                        );

                    default:
                        return (
                            <TemplateIntranet {...props}>
                                <SwitchRouter>
                                    <Route exact path="/login" component={login}/> 
                                    <Route exact path="/" component={HomePage} />
                                    <Route path="/control-docs" component={ControlDocsRoutes} />
                                    <Route path="/fiscal-contabil" component={FiscalContabilRoutes} />
                                    <Route path="/controladoria" component={ControladoriaRoutes} />
                                    <Route path="/combustivel" component={CombustivelRoutes} />
                                    <Route
                                        path="/departamento-pessoal"
                                        component={DepartamentoPessoalRoutes}
                                    />
                                    <Route path="/recebiveis" component={RecebiveisRoutes} />
                                    <Route path="/financeiro" component={FinanceiroRoutes} />
                                    <Route path="/valid-fisco" component={ValidFiscoRoutes} />
                                    <Route
                                        exact
                                        path="/sessao-expirada"
                                        component={SessaoExpiradaPage}
                                    />
                                    <Route exact path="/nao-autorizado" component={ForbiddenPage} />
                                    <Route
                                        exact
                                        path="/pagina-nao-encontrada"
                                        component={NotFoundPage}
                                    />
                                </SwitchRouter>
                            </TemplateIntranet>
                        );
                }
            }}
        />
    );
}
